import React, { useEffect, useState } from "react"
import { subscribeAlert } from "./snackbar-bus"
import CustomSnackbar from "./SnackBar"

export function AlertListener() {
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        variant: "success",
    })

    useEffect(() => {
        const unsubscribe = subscribeAlert((message, variant = "success") => {
            setSnackbar({
                open: true,
                message: message || "Alerta padrão!",
                variant: variant,
            })
        })

        return () => unsubscribe()
    }, [])

    return (
        <CustomSnackbar
            message={snackbar.message}
            variant={snackbar.variant}
            open={snackbar.open}
            onClose={() => setSnackbar(({ ...snackbar, open: false }))}
        />
    )
}